import api from '../../auth/apiClient';
import { SAKTI_API_CONFIG } from '../apiConfig';
import {
  SaktiFilterOptions,
  SaktiFilters,
  SaktiCompanyOption,
  SaktiDivisionOption,
  SaktiEstateOption,
} from '../types';

interface OptionsApiResponse {
  companies?: SaktiCompanyOption[];
  estates?: Array<{ id: number; name: string; odoo_id?: number }>;
  divisis?: SaktiDivisionOption[];
}

interface EstateDbResponseItem {
  id: number;
  name: string;
  company_id: number;
}

export class SaktiApiService {
  static async fetchFilterOptions(): Promise<SaktiFilterOptions> {
    const [optionsResponse, estatesDbResponse] = await Promise.all([
      api.get<OptionsApiResponse>(SAKTI_API_CONFIG.OPTIONS_PATH),
      api.get<EstateDbResponseItem[]>(SAKTI_API_CONFIG.ESTATES_DB_PATH),
    ]);

    const optionsData = optionsResponse.data;
    const estatesDbData = estatesDbResponse.data ?? [];

    const companies = optionsData.companies ?? [];
    const divisions = optionsData.divisis ?? [];

    const estates: SaktiEstateOption[] = estatesDbData.map((estateDb) => {
      const matchedOptionEstate = (optionsData.estates ?? []).find(
        (estate) => estate.name.toLowerCase() === estateDb.name.toLowerCase()
      );

      return {
        id: estateDb.id,
        name: estateDb.name,
        company_id: estateDb.company_id,
        odoo_id: matchedOptionEstate?.odoo_id ?? estateDb.id,
      };
    });

    return {
      companies,
      estates,
      divisions,
    };
  }

  static buildLiveDashboardPath(filters: SaktiFilters): string {
    const params = new URLSearchParams();

    if (filters.company_id) {
      params.set('company_id', String(filters.company_id));
    }
    if (filters.estate_id) {
      params.set('estate_id', String(filters.estate_id));
    }
    if (filters.division_id) {
      params.set('division_id', String(filters.division_id));
    }

    params.set('date', filters.date);

    return `${SAKTI_API_CONFIG.LIVE_DASHBOARD_PATH}?${params.toString()}`;
  }
}

export default SaktiApiService;

